import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { Appointment } from './appointment';
import { Inventory } from '../inventory/inventory';

export interface AppointmentConfirmDialogParams {
	appointment: Appointment,
	duration: number,
	durationLabel: string;
	services: Inventory[];
	isLunch: boolean;
	anyBarber: boolean;
	reoccurring: number;
}

@Component({
  selector: 'app-appointment-confirm-dialog',
  templateUrl: './appointment-confirm-dialog.component.html',
  styleUrls: ['./appointment-confirm-dialog.component.css']
})
export class AppointmentConfirmDialogComponent implements OnInit {

	dateMessage: string;
	dateWarn: boolean;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: AppointmentConfirmDialogParams
	) { }

	get endTime(): Date {
		const d = new Date(this.data.appointment.date),
			dur = this.data.duration;
		d.setMinutes(d.getMinutes() + dur);
		return d;
	}

	ngOnInit() {
		const d = new Date(this.data.appointment.date),
			now = new Date();
		
		d.setHours(0,0,0,0);
		now.setHours(0,0,0,0);

		const x = Math.floor(d.getTime() / 86400000),
			y = Math.floor(now.getTime() / 86400000);

		if (x === y) {
			this.dateWarn = false;
			this.dateMessage = 'Today';
		} else {
			const dif = x - y;
			this.dateWarn = true;
			if (dif === 1) {
				this.dateMessage = 'Tomorrow';
			} else {
				this.dateMessage = `${dif} days from now`;
			}
		}
		
	}

}
